import { ReactNode } from "react";
import css from "./Modal.module.css";

export interface ModalProps {
  isOpen: boolean;
  children: ReactNode;
  onClose: () => void;
}

export const ModalModule = (props: ModalProps) => {
  const { isOpen, children, onClose } = props;
  if (!isOpen) {
    return null;
  }

  return (
    <div className={css["modal-container"]}>
      <div className={css["modal-content"]}>
        <span className={css["close-btn"]} onClick={onClose}></span>
        {children}
      </div>
    </div>
  );
};
